<template>
  <ModalComponent
      :name="'editarMetodoPago-' + pedido.id"
      title="Modificar método de pago del pedido"
      v-on:close="() => close(false)"
  >
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit">
      <div class="row">
        <div class="col-12">
          <label for="metodo_pago">Selecciona método de pago</label>
          <select id="metodo_pago" class="form-control" v-model="pedido.metodo_pago">
            <option v-for="(metodo) in metodosPago" :key="metodo.id" :value="metodo.id">
              {{ metodo.nombre }}
            </option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <button type="submit" name="button" class="btn btn-danger mt-2" id="btn-submit-changes">Guardar</button>
        </div>
      </div>
    </ValidationObserver>
  </ModalComponent>
</template>

<script>
import ModalComponent from "@/components/backend/components/ModalComponent";

export default {
    props: ['pedido', 'sesion_id', 'evento_id'],
    methods: {
        close() {
            this.$emit('close', 'editarMetodoPago-' + this.pedido.id);
        },
        async submit() {
            const data = {
                sesion_id : this.sesion_id,
                evento_id : this.evento_id,
                user_order_id : this.pedido.id,
                metodo_pago: this.pedido.metodo_pago
            };

            this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.pedido.editar.metodo-pago'), data)
                .then(res => {
                    this.$toast.success(res.data.message);

                    this.$emit('updated');
        
                    this.close();
                });
        }
    },
    computed: {
        teatro() {
            return this.$store.getters.getTeatro;
        },
        metodosPago() {
            return this.$store.getters.getTeatro.metodos_pago_eventos_ventas
        }
    },
    components: {
        ModalComponent
    }
}
</script>
